export default __webpack_public_path__ + "static/media/whatsapp_background.bded4f44.png";